module.exports = __webpack_public_path__ + "static/media/opinion_desktop.5e5a9475.svg";